import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import { NavbarV2 } from "./NavbarV2";
import { FooterV2 } from "./FooterV2";
import { ScrollToTop } from "../shared/ScrollToTop";
import { RouteAnnouncer } from "../shared/RouteAnnouncer";
import { Creative3DBackground } from "../shared/Creative3DBackground";

export function LayoutV2() {
  const { pathname } = useLocation();
  const isSolutionPage = pathname.startsWith("/solutions/");
  const isHomePage = pathname === "/";

  return (
    <div className="v2-app v2-brand-atmosphere">
      {!isSolutionPage && !isHomePage && <Creative3DBackground />}
      <RouteAnnouncer />
      <ScrollToTop />
      <NavbarV2 />
      <main id="main-content" tabIndex={-1}>
        <Outlet />
      </main>
      <FooterV2 />
    </div>
  );
}
